import type { ChatQuestion, QuestionAnswer } from '@localagent/sdk';
import { QuestionCard } from './QuestionCard';

export interface QuestionsTabProps {
  questions: ChatQuestion[];
  answered: ChatQuestion[];
  onAnswer: (questionId: string, answer: QuestionAnswer) => Promise<unknown>;
}

export function QuestionsTab({ questions, answered, onAnswer }: QuestionsTabProps) {
  const open = [
    ...questions.filter((q) => q.addresseeKind === 'user'),
    ...questions.filter((q) => q.addresseeKind === 'participant'),
  ];
  return (
    <div data-testid="questions-tab" className="flex h-full min-h-0 flex-col gap-3 overflow-y-auto p-3">
      {open.length === 0 && answered.length === 0 ? (
        <p data-testid="questions-tab-empty" className="py-6 text-center text-caption text-muted-foreground">
          No open questions
        </p>
      ) : null}
      {open.map((q) => (
        <QuestionCard key={q.questionId} question={q} onSubmit={(a) => onAnswer(q.questionId, a)} />
      ))}
      {answered.length > 0 ? (
        <section data-testid="questions-tab-answered" className="flex flex-col gap-2">
          <h3 className="text-label text-muted-foreground">Answered</h3>
          {answered.map((q) => (
            <QuestionCard key={q.questionId} question={q} onSubmit={(a) => onAnswer(q.questionId, a)} />
          ))}
        </section>
      ) : null}
    </div>
  );
}
